import * as types from '../actions/types'

export const initState = {
  accessToken: '',
  isUserLoggedIn: false,
  userName: '',
}

const user = (state = initState, action) => {
  switch (action.type) {
    case types.SET_TOKEN:
      return {
        ...state,
        accessToken: action.token,
      }
    case types.SET_USER_LOGIN:
      return {
        ...state,
        isUserLoggedIn: action.success,
      }
    case types.SET_USER_NAME:
      return {
        ...state,
        userName: action.name,
      }
    default:
      return state
  }
}

export default user
